<template>
    <b-dropdown
        aria-role="list"
        class="language-dropdown"
        :mobile-modal="false"
        :disabled="!hasLanguages"
        :position="position">
        <button class="button is-cancel is-outlined" slot="trigger" :class="{ disabled: !hasLanguages }">
            <span class="icon is-small hideOnCollapse">
                <font-awesome-icon :icon="['fas', 'globe']" />
            </span>
            <span>
                {{ value ? value.toUpperCase() : '' }}
            </span>
            <span class="icon is-small hideOnCollapse" v-if="hasLanguages">
                <font-awesome-icon :icon="['fas', 'angle-down']" />
            </span>
        </button>

        <!--Additional languages-->
        <b-dropdown-item has-link v-for="(language, index) in languages" :key="`lang_${index}`" aria-role="listitem">
            <a href="#" @click.prevent="onLanguage(language.id)">
                {{ language.id.toUpperCase() }} -
                {{ language.name }}
            </a>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import useAppLanguage from './../composables/useAppLanguage.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faGlobe, faAngleDown } from '@fortawesome/free-solid-svg-icons';

library.add(faGlobe);
library.add(faAngleDown);

export default {
    name: 'LocaleChanger',
    components: {
        FontAwesomeIcon,
    },
    props: {
        value: {
            type: String,
        },
        languages: {
            type: Array,
            default: () => [
                {
                    id: 'en',
                    name: 'English',
                },
                {
                    id: 'nl',
                    name: 'Nederlands',
                },
                {
                    id: 'fr',
                    name: 'Français',
                },
            ],
        },
        position: {
            type: String,
            default: 'is-bottom-right',
        },
    },
    setup(props, context) {
        const { locale, updateAppLanguage } = useAppLanguage();
        return { locale, updateAppLanguage };
    },
    data: function () {
        return {};
    },
    created() {
        //send initially set
        if (!this.value) {
            this.$emit('input', this.locale);
        } else {
            this.onLanguage(this.value);
        }
    },
    computed: {
        hasLanguages() {
            return this.languages && this.languages.length > 1;
        },
    },
    methods: {
        onLanguage(value) {
            if (
                this.languages.some((x) => {
                    return x.id == value;
                })
            ) {
                //only updated when supported
                this.updateAppLanguage(value);
                this.$emit('input', value);
            } else {
                console.error('Language not supported');
                this.$emit('input', null);
            }
        },
    },
};
</script>
